import { createContext, useContext, useState } from "react";
import { translations } from "@/lib/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");
  const toggle = () => setLang((l) => (l === "en" ? "es" : "en"));
  const t = (key) => {
    const parts = key.split(".");
    let cur = translations[lang];
    for (const p of parts) cur = cur?.[p];
    return cur ?? key;
  };
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
